<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-6 sm:grid sm:grid-cols-[1fr_3fr]">
    <div class="flex flex-col justify-between gap-6 sm:min-h-0 sm:overflow-auto">
      <form class="flex flex-col gap-4" [formGroup]="form">
        <div class="space-y-2">
          <h3>{{ t('Sélectionnez un modèle de rapport') }}</h3>
          <pxc-report-template-picker formControlName="templateId" [templates]="templates$ | async" />
        </div>
        <div class="space-y-2">
          <h3>{{ t('Données collaboratives') }}</h3>
          <p tuiSubtitle>
            {{ t('Sans groupe sélectionné, seules vos données seront utilisées pour générer le rapport') }}
          </p>
          <pxc-collaborative-departments-picker
            formControlName="departmentIds"
            [departments]="(departments$ | async) ?? []" />
        </div>
        <div class="space-y-2">
          <h3>{{ t('Données à inclure') }}</h3>
          <pxc-sequence-picker-input
            formControlName="sequences"
            [buttonLabel]="t('Modifier')"
            [clientCode]="clientCode()"
            [departmentIds]="form.get('departmentIds').value"
            [editOnMediaClick]="true"
            [patientId]="patient().id"
            [sequenceContext]="sequenceContext">
            <span emptyState>
              {{ t('Toutes les données seront incluses.') }}
            </span>
          </pxc-sequence-picker-input>
        </div>
      </form>

      <ng-content />
    </div>

    <div
      class="flex h-80 w-full items-center justify-center rounded-lg text-center sm:h-full sm:bg-background-tertiary">
      @let pdfPreview = pdfPreview$ | async;

      @if (pdfPreview.isLoading) {
        <pxc-spinner [message]="t('Chargement de l\'aperçu en cours ...')" />
      } @else if (pdfPreview.isSuccess) {
        <pxc-pdf-previewer [source]="pdfPreview.data.preview" />
      } @else if (pdfPreview.hasError) {
        <tui-block-status data-testid="status-fail" size="m">
          <h4>{{ t('Échec') }}</h4>
          {{ t('Une erreur est survenue lors de la génération du rapport') }}
        </tui-block-status>
      } @else {
        <span class="text-text-tertiary">
          {{ t('Sélectionnez un modèle de rapport pour afficher un aperçu.') }}
        </span>
      }
    </div>
  </div>
</ng-container>
